import React from 'react'
import styled, { css } from 'styled-components'

import colors from '../../../vars/colors'
import breakpoints from '../../../vars/breakpoints'

export const ImageGalleryWrapper = styled.section`
  margin-bottom: 20px;
  margin-top: 20px;
  position: relative;

  h2 {
    font-family: "OneDotExt", sans-serif;
    font-weight: bold;
    max-width: 200px;
    text-transform: uppercase;

    @media (min-width: ${breakpoints['bp-desktop']}) {
      margin-bottom: 40px;
    }
  }
`

export const ImageGalleryList = styled.ul`
  display: flex;
  margin-bottom: 20px;
  overflow-x: scroll;
  overflow-y: visible;
  padding-top: 30px;
  scroll-snap-type: x mandatory;
  -ms-overflow-style: -ms-autohiding-scrollbar;

  li {
    flex-shrink: 0;
    max-width: 280px;
    padding-right: 30px;
    transition: transform .2s ease;
    width: 85%;

    &:nth-child(odd) {
      margin-top: 40px;

      @media (min-width: ${breakpoints['bp-desktop']}) {
        margin-top: 80px;
      }
    }
  }

  img {
    border-radius: 10px;
    scroll-snap-align: center;

    @include mq($M) {
      padding: 0 20px;
    }
  }
`

export const ImageGalleryItemWrapper = styled.div`
  position: relative;
`

export const ImageGalleryCity = styled.span`
  bottom: 30px;
  color: ${colors['white']};
  font-family: 'OneDotCd', sans-serif;
  font-size: 2rem;
  font-weight: bold;
  left: 20px;
  position: absolute;
  text-transform: uppercase;
`

export const ImageGalleryState = styled.span`
  color: ${colors['lipstick']};
  font-family: 'OneDotCd', sans-serif;
  font-size: 4rem;
  font-weight: bold;
  left: 20px;
  position: absolute;
  top: -30px;
`

export const ButtonsWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;

  @media (min-width: ${breakpoints['bp-desktop']}) {
    position: absolute;
    right: 0;
    top: 0;
  }
`

export const PrevButton = styled.button`
  background-color: transparent;
  border: none;
  position: relative;
  transition: transform .1s ease-out;
  width: 5rem;
  -webkit-appearance: none;

  &:active {
    transform: scale(.9)
  }

  svg {
    height: auto;
    width: 100%;
  }

  &[disabled] svg path {
    fill: ${colors['light-grey']};
    fill-opacity: .5;
  }

  span {
    color: #fff;
    position: absolute;
    right: 15%;
    text-transform: uppercase;
    top: 48%;
    transform: translateY(-50%);
  }
`

export const NextButton = styled.button`
  background-color: transparent;
  border: none;
  position: relative;
  transition: transform .1s ease-out;
  width: 5rem;
  -webkit-appearance: none;

  &:active {
    transform: scale(.9)
  }

  svg {
    height: auto;
    transform: rotate(180deg);
    width: 100%;
  }

  &[disabled] svg path {
    fill: ${colors['light-grey']};
    fill-opacity: .5;
  }

  span {
    color: #fff;
    left: 15%;
    position: absolute;
    text-transform: uppercase;
    top: 48%;
    transform: translateY(-50%);
  }
`



// WEBPACK FOOTER //
// ./src/components/modules/ImageGallery/styled-components.js